import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { AnnexEffects, AnnexFacade, annexReducer, AnnexState } from './annex';
import { ChatEffects, ChatFacade, chatReducer, ChatState } from './chat';
import { CommentsEffects, CommentsFacade, commentsReducer, CommentsState } from './comments';
import { CommonseEffects, CommonsFacade, commonsReducer, CommonsState } from './commons';
import { CompanyEffects, CompanyFacade, companyReducer, CompanyState } from './company';
import {
  InstructionItemsEffects,
  InstructionItemsFacade,
  instructionItemsReducer,
  InstructionItemsState,
} from './instruction-items';
import { ManagementEffects, ManagementFacade, managementReducer, ManagementState } from './management';
import {
  InAppNotificationsEffects,
  InAppNotificationsFacade,
  inAppNotificationsReducer,
  InAppNotificationsState,
} from './notifications';
import { OfficeEffects, OfficeFacade, officeReducer, OfficeState } from './office';
import { ReviewEffects, ReviewFacade, reviewReducer, ReviewState } from './review';
import { RouterEffects, RouterFacade, RouterStateUrl } from './router';
import { SupportChatEffects, SupportChatFacade, supportChatReducer, SupportChatState } from './support-chat';
import {
  SystemSettingsEffects,
  SystemSettingsFacade,
  systemSettingsReducer,
  SystemSettingsState,
} from './system-settings';
import { UserAssetsEffects, UserAssetsFacade, userAssetsReducer, UserAssetsState } from './user-assets';
import { UserAuthEffects, UserAuthFacade, userAuthReducer, UserAuthState } from './user-auth';
import { UserFilesEffects, UserFilesFacade, userFilesReducer, UserFilesState } from './user-files';
import { UserProcessEffects, UserProcessFacade, userProcessReducer, UserProcessState } from './user-process';
import { UsersEffects, UsersFacade, usersReducer, UsersState } from './users';
import {
  VisitsCalendarEffects,
  VisitsCalendarFacade,
  visitsCalendarReducer,
  VisitsCalendarState,
} from './visits-calendar';
import { VoivodeshipsEffects, VoivodeshipsFacade, voivodeshipsReducer, VoivodeshipsState } from './voivodeships';

import { BackOfficeEffects, BackOfficeFacade, backOfficeReducer, BackOfficeState } from './back-office';
import { DiscountCodesEffects, DiscountCodesFacade, discountCodesReducer, DiscountCodesState } from './discount-codes';
import {
  MyPartnerAccountEffects,
  MyPartnerAccountFacade,
  myPartnerAccountReducer,
  MyPartnerAccountState,
} from './my-partner-account';
import { PartnerCodesEffects, PartnerCodesFacade, partnerCodesReducer, PartnerCodesState } from './partner-codes';
import { PurchaseEffects, PurchaseFacade, purchaseReducer, PurchaseState } from './purchase';
import {
  UserDocumentsManagementEffects,
  UserDocumentsManagementFacade,
  userDocumentsManagementReducer,
  UserDocumentsManagementState,
} from './user-documents-management';

import { ManagerEffects, ManagerFacade, managerReducer, ManagerState } from './manager';

import {
  UserSupportingCompanyEffects,
  UserSupportingCompanyFacade,
  userSupportingCompanyReducer,
  UserSupportingCompanyState,
} from './user-supporting-company';

export const reducers = {
  router: routerReducer,
  userAuth: userAuthReducer,
  company: companyReducer,
  users: usersReducer,
  userProcess: userProcessReducer,
  userDocumentsManagement: userDocumentsManagementReducer,
  commons: commonsReducer,
  management: managementReducer,
  comments: commentsReducer,
  systemSettings: systemSettingsReducer,
  inAppNotifications: inAppNotificationsReducer,
  chat: chatReducer,
  voivodeships: voivodeshipsReducer,
  visitsCalendar: visitsCalendarReducer,
  instructionItems: instructionItemsReducer,
  office: officeReducer,
  review: reviewReducer,
  annex: annexReducer,
  supportChat: supportChatReducer,
  userFiles: userFilesReducer,
  userAssets: userAssetsReducer,
  purchase: purchaseReducer,
  discountCodes: discountCodesReducer,
  backOffice: backOfficeReducer,
  partnerCodes: partnerCodesReducer,
  myPartnerAccount: myPartnerAccountReducer,
  manager: managerReducer,
  userSupportingCompany: userSupportingCompanyReducer,
};

export const effects = [
  RouterEffects,
  UserAuthEffects,
  CompanyEffects,
  UsersEffects,
  UserProcessEffects,
  UserDocumentsManagementEffects,
  CommonseEffects,
  ManagementEffects,
  CommentsEffects,
  SystemSettingsEffects,
  InAppNotificationsEffects,
  ChatEffects,
  VoivodeshipsEffects,
  VisitsCalendarEffects,
  InstructionItemsEffects,
  OfficeEffects,
  ReviewEffects,
  AnnexEffects,
  SupportChatEffects,
  UserFilesEffects,
  UserAssetsEffects,
  PurchaseEffects,
  DiscountCodesEffects,
  BackOfficeEffects,
  PartnerCodesEffects,
  MyPartnerAccountEffects,
  ManagerEffects,
  UserSupportingCompanyEffects,
];

export const facades = [
  RouterFacade,
  UserAuthFacade,
  CompanyFacade,
  UsersFacade,
  UserProcessFacade,
  UserDocumentsManagementFacade,
  CommonsFacade,
  ManagementFacade,
  CommentsFacade,
  SystemSettingsFacade,
  InAppNotificationsFacade,
  ChatFacade,
  VoivodeshipsFacade,
  VisitsCalendarFacade,
  InstructionItemsFacade,
  OfficeFacade,
  ReviewFacade,
  AnnexFacade,
  SupportChatFacade,
  UserFilesFacade,
  UserAssetsFacade,
  PurchaseFacade,
  DiscountCodesFacade,
  BackOfficeFacade,
  PartnerCodesFacade,
  MyPartnerAccountFacade,
  ManagerFacade,
  UserSupportingCompanyFacade,
];

export interface AppState {
  router: RouterReducerState<RouterStateUrl>;
  userAuth: UserAuthState;
  company: CompanyState;
  users: UsersState;
  userProcess: UserProcessState;
  userDocumentsManagement: UserDocumentsManagementState;
  commons: CommonsState;
  management: ManagementState;
  comments: CommentsState;
  systemSettings: SystemSettingsState;
  inAppNotifications: InAppNotificationsState;
  chat: ChatState;
  voivodeships: VoivodeshipsState;
  visitsCalendar: VisitsCalendarState;
  instructionItems: InstructionItemsState;
  office: OfficeState;
  review: ReviewState;
  annex: AnnexState;
  supportChat: SupportChatState;
  userFiles: UserFilesState;
  userAssets: UserAssetsState;
  purchase: PurchaseState;
  discountCodes: DiscountCodesState;
  backOffice: BackOfficeState;
  partnerCodes: PartnerCodesState;
  myPartnerAccount: MyPartnerAccountState;
  manager: ManagerState;
  userSupportingCompany: UserSupportingCompanyState;
}
